/**
 * Tooltip texts of `SpecialChargesIcon.tsx` in English, French and Spanish, one per icon `type`.
 */
import { LanguageContent } from "@ryerson/frontend.common";

interface SpecialChargesIconLanguage {
    orderItemSpecialChargesTooltipText?: string;
    orderSpecialChargesTooltipText?: string;
    quoteSpecialChargesTooltipText?: string;
}

/** The tooltip texts by language. */
export const withLanguage: LanguageContent<SpecialChargesIconLanguage> = {
    en: {
        orderItemSpecialChargesTooltipText: "This item contains special charges. Contact your sales rep for details.",
        orderSpecialChargesTooltipText: "This order contains special charges. Contact your sales rep for details.",
        quoteSpecialChargesTooltipText: "This quote contains special charges. Contact your sales rep for details."
    },
    fr: {
        orderItemSpecialChargesTooltipText: "Cet article contient des frais spéciaux. Communiquez avec votre représentant commercial pour plus de détails.",
        orderSpecialChargesTooltipText: "Cette commande contient des frais spéciaux. Communiquez avec votre représentant commercial pour plus de détails.",
        quoteSpecialChargesTooltipText: "Ce devis contient des frais spéciaux. Communiquez avec votre représentant commercial pour plus de détails." 
    },
    es: {
        orderItemSpecialChargesTooltipText: "Este artículo incluye cargos especiales. Comuníquese con su representante de ventas para más detalles.",
        orderSpecialChargesTooltipText: "Este pedido incluye cargos especiales. Comuníquese con su representante de ventas para más detalles.",
        quoteSpecialChargesTooltipText: "Esta cotización incluye cargos especiales. Comuníquese con su representante de ventas para más detalles."
    }
};